import moment, { Moment } from "moment";

export const getFormattedUtcToLocal = (dateString: string) => {
  return getUtcToLocal(dateString).format("MMM DD, YYYY hh:mm:ss");
};

export const getUtcToLocal = (dateString: string) => {
  return moment.utc(dateString).local();
};

export const getFullDateFromString = (dateString: string) => {
  return moment(dateString).format("YYYY/MM/DD");
};

export const getMonthAndDayOrdinalString = (dateTimeString: string) => {
  return moment(dateTimeString).format("MMMM Do");
};

export const getDateTime = (dateTime: string | undefined) => {
  const format = "YYYY-MM-DD HH:mm:ss";

  if (!dateTime) {
    return moment();
  }

  return moment(dateTime, format);
};

export const getDateMonthNameYearFromString = (dateString: string) => {
  return moment(dateString).format("DD MMMM YYYY");
};

export const getMonthsStartAndEndDate = (dateTime: Moment) => {
  return [dateTime.clone().startOf("month"), dateTime.clone().endOf("month")];
};

export const getYearsStartAndEndDate = (dateTime: Moment) => {
  return [dateTime.clone().startOf("year"), dateTime.clone().endOf("year")];
};

export const checkIfDateIsFromCurrentMonth = (date: Moment) => {
  return date.isSame(moment(), "month");
};

export const checkIfDateIsFromCurrentYear = (date: Moment) => {
  return date.isSame(moment(), "year");
};

export const checkIfDateIsAfterTodayFromString = (date: string) => {
  return moment(date).isAfter(moment());
};

export const checkIfDateIsAfterToday = (date: Moment) => {
  return date.isAfter(moment());
};

export const addYearsWithGivenDate = (date: string, years: number) => {
  return moment(date).add(years, "years").format("YYYY-MM-DDTHH:mm:ss");
};
